import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 11, viewBox: "0 0 12 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 6.2004L3.7786 8.63644C4.33606 9.39995 5.48029 9.38512 6.0178 8.6074L10.5842 2", stroke: "currentColor", strokeWidth: 2.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTick);
export default ForwardRef;
